import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as backInter from 'app/auth/auth-data.model';
import { DATOS_API } from 'app/auth/auth.datos';
/// SERVICIO DE AUTENTICACION
import { AuthService } from 'app/auth/auth.service';

import { BehaviorSubject } from 'rxjs';
import { nps } from '../../../auth/auth-data.model';

@Injectable({
  providedIn: 'root'
})
export class NpsService {

  idEmpresa: string;
  idUsuario: string;

  private mensajeOrigen = new BehaviorSubject('');
  mensajeActual = this.mensajeOrigen.asObservable();

  constructor(
    private http:HttpClient,
    private authService:AuthService
  ) {
    this.obtienInfo();
  }

  obtienInfo()
  {
    this.idUsuario = this.authService.getIdUsuario();
    let infoUsu: backInter.infoUsuario = this.authService.getInfoUsuario();
    this.idEmpresa = infoUsu.empresaId;
  }

  puenteDatos(mensaje: string) {
    this.mensajeOrigen.next(mensaje);
  }

  getProdCertAct(){
    this.obtienInfo();
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.productos + this.idEmpresa);
  }

  getStatusNps(productoId: any){
    this.obtienInfo();
    let datos: any = {productoId,	nps: 1};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getStatusPart + this.idEmpresa, datos);
  }

  guardaStatusNps(datos){
    this.obtienInfo();
    console.log("nps datos::",datos);
    // let datos: any = {fechaCertificar: anio,	nps: 3};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.guardaStatus + this.idEmpresa, datos);
  }

  DesbloquearPasoNps(datos){
    this.obtienInfo();
    console.log("nps datos::",datos);
    // let datos: any = {fechaCertificar: anio,	nps: 2};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.guardaStatus + this.idEmpresa, datos);
  }

  getStatusNpsMedir(anio: any){
    this.obtienInfo();
    let datos: any = {productoId: anio,	nps: 1};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.medir.getStatusPart + this.idEmpresa, datos);
  }

  getStatusNpsMedir2(anio: any){
    this.obtienInfo();
    let datos: any = {productoId: anio,	nps: 1};
    console.log("get estatus medir");
    console.log(datos);
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.medir.getStatusPart + this.idEmpresa, datos);
  }

  guardaStatusNpsMedir(anio: any){
    this.obtienInfo();
    let datos: any = {productoId: anio,	nps: 3};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.medir.guardaStatus + this.idEmpresa, datos);
  }

  DesbloquearPasoNpsMedir(anio: any){
    this.obtienInfo();
    let datos: any = {productoId: anio,	nps: 2};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.medir.guardaStatus + this.idEmpresa, datos);
  }

  // Nuevo servicio para crear validaciones de traducciones
  public getTraducciones(data){
    this.obtienInfo();
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.nps.getTraducciones+this.idEmpresa,data);
    // return this.httpClient.post(this.ip+'/api_empresa/getTraduccionesReactivos/'+this.getCompanyID(),data,
    //{ headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

}
